/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { ContactTermsReceivables } from '@gh/builder-shared-data';
import { NumberTypes, toAppFormGroup, updateChildrenSchema } from '@gh/common-shared';
import { getControlValue } from '@gh/core-ui';

import {
  ContactTermsPayer,
  isTermsReceivablesAllowDays,
  isTermsReceivablesBalanceAsDayOfMonth,
  isTermsReceivablesDueDateRequired,
} from '../../resources/model/contact-shared.model';

const getTermsPayerSchema = (payment: ContactTermsPayer) => {
  const isDueDaysRequired = isTermsReceivablesDueDateRequired(payment.paymentIsDue);
  const isDueDateOfMonth = isTermsReceivablesBalanceAsDayOfMonth(payment.paymentIsDue);
  const allowDays = isTermsReceivablesAllowDays(payment.paymentIsDue);

  return {
    paymentIsDue: { required: true },
    dueDays: {
      required: isDueDaysRequired,
      enabled: allowDays,
      type: isDueDateOfMonth ? NumberTypes.DayOfMonth : NumberTypes.Days,
    },
    discountDays: { enabled: allowDays, type: NumberTypes.Days },
    discountPct: { type: NumberTypes.Percents_2 },
  };
};

@Injectable()
export class ContactDetailsSharedTermsPayerFormStateFactory {
  constructor(private schemaFactory: BuilderFormSchemaFactory) {

  }

  create(): ContactDetailsSharedTermsPayerFormState {
    return new ContactDetailsSharedTermsPayerFormState(this.schemaFactory);
  }
}

export class ContactDetailsSharedTermsPayerFormState extends FormState<ContactTermsPayer> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  get paymentIsDue(): ContactTermsReceivables {
    return getControlValue(this.group, 'paymentIsDue');
  }

  update(): void {
    updateChildrenSchema(toAppFormGroup(this.group), getTermsPayerSchema(this.group.value));
  }

  protected buildSchema(terms: ContactTermsPayer, { root }: FormStateSchema): FormRootSchema {
    return root({
      children: getTermsPayerSchema(terms),
    });
  }
}
